module.exports = __webpack_public_path__ + "static/media/belt-replacement.eca2150b.svg";